import { Button, Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { COVID_19 } from "navigation/CONSTANTS";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
  },
  box: {
    border: `1px solid #dadce0`,
    padding: 16,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
  },
}));

const AltRegistrationSuccess = () => {
  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  const handleClick = () => {
    history.push(COVID_19);
  };

  return (
    <Container
      maxWidth="sm"
      style={{ paddingBottom: 148, paddingTop: 24, flexGrow: 1 }}
    >
      <Grid container item direction="column" alignItems="stretch">
        <Grid
          item
          container
          className={classes.header}
          direction="column"
          alignItems="stretch"
        >
          <Grid item>
            <Typography style={{ fontSize: 20 }}>Form submitted.</Typography>
          </Grid>
          <Grid item style={{ marginTop: 16 }}>
            <Typography style={{ fontSize: 14 }} color="textPrimary">
              Thank you for submitting the form. Your vaccination details have
              been saved.
            </Typography>
          </Grid>
          <Grid
            item
            style={{
              marginTop: 16,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              disableElevation
              onClick={handleClick}
              style={{ textTransform: "none" }}
            >
              Submit another entry
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AltRegistrationSuccess;
